var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { is, fromJS as Immutable } from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { t } from "../../I18N";
import ShowIf from "../../App/ShowIf";
import { Icon } from "../../UI";

import { setFilter } from "../actions/actions";

class ConnectionsGroup extends Component {
  static getDerivedStateFromProps(props, state) {
    if (props.group.get('templates').size > state.groupTemplates.size) {
      return {
        selected: false,
        groupTemplates: props.group.get('templates')
      };
    }

    return { groupTemplates: props.group.get('templates') };
  }

  constructor(props) {
    super(props);
    this.state = {
      expanded: true,
      selected: false,
      selectedItems: Immutable([]),
      groupTemplates: Immutable([])
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !is(this.props.group, nextProps.group) ||
      this.state.expanded !== nextState.expanded ||
      this.state.selected !== nextState.selected ||
      this.state.selectedItems.size !== nextState.selectedItems.size);

  }

  setGroupFilter(selectedItems) {
    const newFilter = {};
    newFilter[this.props.group.get('key')] = selectedItems;
    this.props.setFilter(newFilter);
  }

  toggleSelectItem(item) {
    let selectedItems;
    let groupSelected;

    if (this.state.selectedItems.includes(item)) {
      groupSelected = false;
      selectedItems = this.state.selectedItems.splice(this.state.selectedItems.indexOf(item), 1);
    }

    if (!this.state.selectedItems.includes(item)) {
      selectedItems = this.state.selectedItems.push(item);
      groupSelected = selectedItems.size === this.props.group.get('templates').size;
    }

    this.setGroupFilter(selectedItems);
    this.setState({ selectedItems, selected: groupSelected });
  }

  toggleSelectGroup() {
    const { group } = this.props;
    const selectedItems = !this.state.selected ?
    group.get('templates').map((i) => group.get('key') + i.get('_id')) :
    Immutable([]);

    this.setGroupFilter(selectedItems);
    this.setState((currentState) => ({ selected: !currentState.selected, selectedItems }));
  }

  toggleExpandGroup() {
    this.setState((currentState) => ({ expanded: !currentState.expanded }));
  }

  render() {
    const group = this.props.group.toJS();
    const { connectionLabel, templates } = group;
    return (/*#__PURE__*/
      _jsx("li", { className: "relationshipFilters" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "multiselectItem" }, void 0, /*#__PURE__*/
      _jsx("input", {
        type: "checkbox",
        className: "form-control multiselectItem-input",
        id: `group${group.key}`,
        onChange: this.toggleSelectGroup.bind(this),
        checked: this.state.selected }
      ), /*#__PURE__*/
      _jsx("label", { htmlFor: `group${group.key}`, className: "multiselectItem-label" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-icon" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: ['far', 'square'], className: "checkbox-empty" }), /*#__PURE__*/
      _jsx(Icon, { icon: "check", className: "checkbox-checked" })
      ), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-name" }, void 0, /*#__PURE__*/
      _jsx("b", {}, void 0, group.key ? t(group.context, connectionLabel) : t('System', 'No Label'))
      )
      ), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-results" }, void 0, /*#__PURE__*/
      _jsx("span", {}, void 0, group.templates.reduce((size, i) => size + i.count, 0))
      ), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-action", onClick: this.toggleExpandGroup.bind(this) }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: this.state.expanded ? 'caret-up' : 'caret-down' })
      )
      ), /*#__PURE__*/
      _jsx(ShowIf, { if: this.state.expanded }, void 0, /*#__PURE__*/
      _jsx("ul", { className: "multiselectChild is-active" }, void 0,
      templates.map((template, index) => /*#__PURE__*/
      _jsx("li", { className: "multiselectItem", title: template.label }, index, /*#__PURE__*/
      _jsx("input", {
        type: "checkbox",
        className: "multiselectItem-input",
        id: group.key + template._id,
        onChange: this.toggleSelectItem.bind(this, group.key + template._id),
        checked: this.state.selectedItems.includes(group.key + template._id) }
      ), /*#__PURE__*/
      _jsx("label", { className: "multiselectItem-label", htmlFor: group.key + template._id }, void 0, /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-icon" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: ['far', 'square'], className: "checkbox-empty" }), /*#__PURE__*/
      _jsx(Icon, { icon: "check", className: "checkbox-checked" })
      ), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-name" }, void 0, t(template._id, template.label))
      ), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-results" }, void 0, template.count), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-action placeholder" })
      )
      )
      )
      )
      ));

  }
}






const mapDispatchToProps = (dispatch) =>
bindActionCreators(
  {
    setFilter
  },
  dispatch
);

export { ConnectionsGroup, mapDispatchToProps };
export default connect(null, mapDispatchToProps)(ConnectionsGroup);